/**
 * @file InfoLine.tsx
 * @description Строка-сетка сведений под шапкой карточки (phase19.31, SC61,
 * SC63): «Сумма 7 500,00 ₽ · Срок — · Ответственный А. Кравец · …».
 *
 * Заменяет плитки показателей в карточках сделки и клиента: сведения
 * читаются одной строкой, а не занимают пол-экрана. На широком экране пары
 * «подпись значение» идут в строку с переносом; на телефоне — сеткой в две
 * колонки (подпись над значением), чтобы длинные имена не рвали строку.
 * Подписи — обычным регистром, вторым цветом; значения — текст 14/500.
 */

import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface InfoLineItem {
  key: string;
  label: string;
  value: ReactNode;
  /** Янтарный текст значения (просрочка). */
  tone?: "default" | "attention";
}

interface Props {
  items: InfoLineItem[];
  "aria-label": string;
  className?: string;
}

export function InfoLine({ items, className, "aria-label": ariaLabel }: Props) {
  if (items.length === 0) return null;
  return (
    <dl
      aria-label={ariaLabel}
      className={cn("grid grid-cols-2 gap-x-4 gap-y-2 md:flex md:flex-wrap md:items-baseline md:gap-x-6", className)}
    >
      {items.map((item) => (
        <div key={item.key} className="flex min-w-0 flex-col md:flex-row md:items-baseline md:gap-1.5">
          <dt className="type-caption text-on-surface-variant">{item.label}</dt>
          <dd
            className={cn(
              "type-body min-w-0 break-words font-medium tabular-nums",
              item.tone === "attention" ? "text-[var(--status-attention-fg)]" : "text-on-surface",
            )}
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
